import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconCheckedBox.module.css';

const IconCheckedBox = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7072 10.7071L17.293 9.29289L10.0001 16.5858L6.70718 13.2929L5.29297 14.7071L10.0001 19.4142L18.7072 10.7071Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.33333V24H24V5.33333L18.5455 0H5.45455L0 5.33333ZM2 7.33333H22V22H2V7.33333ZM21.1393 5.33333H2.86075L6.26984 2H17.7302L21.1393 5.33333Z"
        fill="black"
      />
    </svg>
  );
};

IconCheckedBox.defaultProps = { className: null };

IconCheckedBox.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconCheckedBox;
